import React, { useEffect, useState } from "react";
import VideoPlayer from '../common/VideoPlayer';
import CardNewsGallery from '../common/CardNewsGallery';
import FeaturedVideo from './FeaturedVideo';
import ContentGallery from './ContentGallery';
import { FaHandsHelping } from 'react-icons/fa';
import './GuideLife_01.scss';

const GuideLife_02 = ({ 
sectionTitle = "교내 활동 안내",
sectionIcon = <FaHandsHelping />,
kickerText = "새내기 추천 영상",
subText = "다양한 동아리와 자치 활동, 캠퍼스 프로그램과 행사를 통해 지스트만의 활기찬 문화를 만나보세요.",
contents = []
}) => {

// 기본 콘텐츠 데이터
const defaultContents = [
    {
    id: "act-yt-1",
    type: "youtube",
    topic: "activity",
    title: "GIST 재학생이 들려주는 동아리 이야기",
    url: "https://youtu.be/9tV5lS1DGRY",
    thumb: "https://img.youtube.com/vi/9tV5lS1DGRY/maxresdefault.jpg",
    desc: "교내 생활을 더욱 알차게 만들어주는 다양한 활동을 소개합니다.",
    featured: true,
    },
    {
        id: "act-yt-3",
        type: "youtube",
        topic: "activity",
        title: "GIST대학 동아리 안내",
        url: "https://youtu.be/Ssxe7zRNe_c",
        thumb: "https://img.youtube.com/vi/Ssxe7zRNe_c/maxresdefault.jpg",
        desc: "교내 활동 시작할 때 도움이 되는 영상이에요.",
    },
    {
        id: "act-yt-4",
        type: "youtube",
        topic: "activity",
        title: "과학기술특성화대학이 모두 모였다!",
        url: "https://youtu.be/N_ywx2c327U",
        thumb: "https://img.youtube.com/vi/N_ywx2c327U/maxresdefault.jpg",
        desc: "[GGUN 제작] 2025 STadium in GIST",
    },
    {
        id: "act-cn-1",
        type: "cardnews",
        topic: "activity",
        title: "동아리",
        thumb: "/images/guide1/001.jpg",
        desc: "GIST 동아리 한 번에 정리!",
        images: ["/images/guide1/001.jpg","/images/guide1/002.jpg","/images/guide1/003.jpg",
                "/images/guide1/004.jpg","/images/guide1/004.jpg","/images/guide1/005.jpg",
                "/images/guide1/006.jpg","/images/guide1/007.jpg","/images/guide1/008.jpg","/images/guide1/009.jpg",
                ],
    },
    {
        id: "act-cn-2",
        type: "cardnews",
        topic: "activity",
        title: "자치회",
        thumb: "/images/guide1/010.jpg",
        desc: "GIST 자치회 한 번에 정리!",
        images: ["/images/guide1/010.jpg","/images/guide1/011.jpg","/images/guide1/012.jpg","/images/guide1/013.jpg",
                "/images/guide1/014.jpg","/images/guide1/015.jpg","/images/guide1/016.jpg","/images/guide1/017.jpg",
                ],
    },
    {
        id: "act-cn-3",
        type: "cardnews",
        topic: "activity",
        title: "지온나래",
        thumb: "/images/guide1/018.jpg",
        desc: "지온나래 활동 한 번에 정리!",
        images: ["/images/guide1/018.jpg","/images/guide1/019.jpg","/images/guide1/020.jpg","/images/guide1/021.jpg",
                "/images/guide1/022.jpg","/images/guide1/023.jpg","/images/guide1/024.jpg","/images/guide1/025.jpg",
                ],
    },
    {
        id: "act-cn-4",
        type: "cardnews",
        topic: "activity",
        title: "신입생캠프",
        thumb: "/images/guide1/01.png",
        desc: "2023 지스트 신입생캠프 돌아보기",
        images: ["/images/guide1/01.png","/images/guide1/02.png","/images/guide1/03.png","/images/guide1/04.png",
                "/images/guide1/05.png","/images/guide1/06.png","/images/guide1/07.png","/images/guide1/08.png",
                ],
    },
    {
        id: "act-cn-5",
        type: "cardnews",
        topic: "activity",
        title: "스타디움",
        thumb: "/images/guide1/1.png",
        desc: "2025 STadium in GIST",
        images: ["/images/guide1/1.png","/images/guide1/2.png","/images/guide1/3.png","/images/guide1/4.png",
                "/images/guide1/5.png","/images/guide1/6.png","/images/guide1/7.png","/images/guide1/8.png","/images/guide1/9.png",
                ],
    },
    {
        id: "act-cn-6",
        type: "cardnews",
        topic: "activity",
        title: "루미에르",
        thumb: "/images/guide1/10.png",
        desc: "지스트 가을행사 루미에르",
        images: ["/images/guide1/10.png","/images/guide1/11.png","/images/guide1/12.png","/images/guide1/13.png",
                "/images/guide1/14.png","/images/guide1/15.png","/images/guide1/16.png",
                ],
    },
];

// props로 받은 contents가 있으면 사용, 없으면 기본 데이터 사용
const displayContents = contents.length > 0 ? contents : defaultContents;

// ✅ 모달
const [selected, setSelected] = useState(null);

const openContent = (c) => {
    setSelected(c);
};

const closeModal = () => {
    setSelected(null);
};

// ESC 키로 모달 닫기
useEffect(() => {
    const onKeyDown = (e) => {
    if (e.key === "Escape") closeModal();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
}, []);

// featured content 찾기
const featuredContent = displayContents.find((c) => c.topic === "activity" && c.featured && c.type === "youtube") ||
    displayContents.find((c) => c.topic === "activity" && c.type === "youtube") ||
    null;

//======================================================================================
return (
    <div className="GuideLife_container">
    <div className="hub-container">
        <h3 className="section-title">
        <span className="section-icon">{sectionIcon}</span>
        {sectionTitle}
        </h3>

        <div className="hub">
        <FeaturedVideo 
            kicker={kickerText}
            sub={subText}
            featured={featuredContent}
            onOpenContent={openContent}
        />
        
        <ContentGallery 
            contents={displayContents.filter((c) => c.topic === "activity")}
            onOpenContent={openContent}
        />
        </div>
    </div>

    {/* ✅ Modal */}
    {selected && selected.type === "youtube" && (
        <VideoPlayer
        url={selected.url}
        title={selected.title}
        onClose={closeModal}
        />
    )}
    
    {selected && selected.type === "cardnews" && (
        <CardNewsGallery
        images={selected.images}
        title={selected.title}
        onClose={closeModal}
        />
    )}
    </div>
);
};

export default GuideLife_02;